import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import HotelTabManagerWithHotelStandalone from './HotelTabManagerWithHotelStandalone';
import { WithHotelErrorBoundary } from '../WithHotelErrorBoundary';
import { setChainFilter } from '../../../redux/currentSearch/actions';

const HotelDesktop = ({ rootDataAttr = {}, setChainFilter }) => {
    useEffect(() => {
        if (rootDataAttr.chainFilter) {
            setChainFilter(rootDataAttr.chainFilter);
        }
    }, [rootDataAttr.chainFilter, setChainFilter]);

    return <HotelTabManagerWithHotelStandalone />;
};

HotelDesktop.propTypes = {
    rootDataAttr: PropTypes.object,
    setChainFilter: PropTypes.func.isRequired,
};

const HotelDesktopWithErrorBoundary = WithHotelErrorBoundary(HotelDesktop);

export const HotelTabManager = connect(createStructuredSelector({}), {
    setChainFilter,
})(HotelDesktopWithErrorBoundary);
